type ResponsiveImageType = {
  src: string
  width?: number
  height?: number
}

export function ResponsiveImg({
  img,
  imgMobile,
  imgMobileMaxSizeCoefficient = 0.6,
}: {
  img: ResponsiveImageType
  imgMobile?: ResponsiveImageType
  imgMobileMaxSizeCoefficient?: number
}) {
  const style = getImageMaxSizesStyle(
    imgMobile || img,
    imgMobileMaxSizeCoefficient,
  )

  return (
    <>
      <div className={'image_desktop'}>
        <img src={img.src} alt='' loading='lazy' />
      </div>
      <div className={'image_mobile'}>
        <img src={(imgMobile || img).src} alt='' loading='lazy' style={style} />
      </div>
    </>
  )
}

function getImageMaxSizesStyle(
  image: ResponsiveImageType,
  coefficient: number,
): Record<'maxWidth' | 'maxHeight', string> {
  if (!image.width && !image.height) {
    // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type 'Record... Remove this comment to see the full error message
    return undefined
  }

  const getSizeString = (size: number) =>
    size ? `${Math.floor(size * coefficient)}px` : undefined

  return {
    // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    maxWidth: getSizeString(image.width),
    // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    maxHeight: getSizeString(image.height),
  }
}
